export const TWO_FACTOR_CONFIG = {
  /**
   * Number of recovery codes generated for each user.
   */
  RECOVERY_CODES_COUNT: 8,

  /**
   * App name displayed in authenticator apps.
   */
  APP_NAME: 'LtDan',

  /**
   * LocalStorage key for tracking if user has dismissed 2FA setup prompt.
   * Used for existing users who haven't set up 2FA yet.
   */
  SETUP_PROMPT_DISMISSED_KEY: 'ltdan_2fa_prompt_dismissed',

  /**
   * LocalStorage key for tracking when user last saw the 2FA prompt.
   */
  SETUP_PROMPT_LAST_SHOWN_KEY: 'ltdan_2fa_prompt_last_shown',
} as const;

export type TwoFactorConfig = typeof TWO_FACTOR_CONFIG;
